if (!customElements.get("main-collection-2-filter-form")) {
  class MainCollection2FilterForm extends HTMLElement {
    static clearFiltersListenerAttached = false;
    static activeFiltersListenerAttached = false;
    constructor() {
      super();

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);

      const formEl = this.querySelector('form');
      formEl?.addEventListener('input', (event) => {
        event.target.classList.add("main-collection-2__input--loading");
        this.debouncedOnSubmit(event);
      }); 
    }

    connectedCallback() {
      // TO FETCH AVAILABLE PRODUCTS ON LOAD
      MainCollection2FilterForm.applyAvailabilityFilter();
      // TO CLEAR FILTERS
      if (!MainCollection2FilterForm.clearFiltersListenerAttached){
        document.addEventListener("main-collection-2:filters:clear", (event)=>{MainCollection2FilterForm.clearFilters(event, this)});
        MainCollection2FilterForm.clearFiltersListenerAttached = true;
      }
      MainCollection2FilterForm.updateClearFilterButtonVisibility(MainCollection2FilterForm.searchParamsPrev);
      // ACTIVE FILTER
      if (!MainCollection2FilterForm.activeFiltersListenerAttached){
        document.addEventListener("main-collection-2:active-filter-click", (event)=> {
          MainCollection2FilterForm.activeFilter(event);
        })
        MainCollection2FilterForm.activeFiltersListenerAttached = true;
      }
    }

    static setListeners(){
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : MainCollection2FilterForm.searchParamsInitial;
        if (searchParams === MainCollection2FilterForm.searchParamsPrev) return;
        MainCollection2FilterForm.renderPage(searchParams, null, false);
        console.log("HISTORY CHANGE");
      };

      window.addEventListener('popstate', onHistoryChange);
    }

    static applyAvailabilityFilter() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const availability = urlSearchParams.get('filter.v.availability');

      if (availability === '1') {
        return;
      }

      urlSearchParams.set('filter.v.availability', '1');
      MainCollection2FilterForm.renderPage(
        urlSearchParams.toString(),
        null,
        false, 
        true,
        true
      );  
    }

    static renderPage(searchParams, event, instance, updateURLHash = true, initialLoad = false){
      document.documentElement.setAttribute("main-collection-2-loading", "true");
      MainCollection2FilterForm.searchParamsPrev = searchParams;

      const sections = MainCollection2FilterForm.getSections();
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        // console.log(url);
        const filterDataUrl = (element) => element.url === url;
        
        MainCollection2FilterForm.filterData.some(filterDataUrl)
        ? MainCollection2FilterForm.renderSectionFromCache(filterDataUrl, event, instance, initialLoad)
        : MainCollection2FilterForm.renderSectionFromFetch(url, event, instance, initialLoad);
      });

      if (updateURLHash) MainCollection2FilterForm.updateURLHash(searchParams);
      MainCollection2FilterForm.updateClearFilterButtonVisibility(searchParams);
      MainCollection2FilterForm.publishEvents(event);
    }


    static renderSectionFromFetch(url, event, instance, initialLoad) {
      fetch(url)
      .then(res => res.text())
      .then(responseText => {
        const html = responseText;
        MainCollection2FilterForm.filterData = [...MainCollection2FilterForm.filterData, { html, url }];
        
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        
        MainCollection2FilterForm.renderFilters(parsedHTML, event);
        MainCollection2FilterForm.renderActiveFilters(parsedHTML, event);
        MainCollection2FilterForm.renderPriceRangeSlider(parsedHTML, event);
        // MainCollection2FilterForm.renderPriceRange(parsedHTML, event);
        MainCollection2FilterForm.renderSort(parsedHTML, event);
        MainCollection2FilterForm.renderAppliedFiltersCount(parsedHTML);
        MainCollection2FilterForm.renderAvailableProductsCount(parsedHTML);
        MainCollection2FilterForm.renderProductGrid(parsedHTML);
        MainCollection2FilterForm.renderInfiniteScroll(parsedHTML);

        document.documentElement.removeAttribute("main-collection-2-loading");

        requestAnimationFrame(() => {
          const productGrid = document.getElementById('product-grid');
          if (productGrid) {
            const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--new-header-height'), 10);
            let top = productGrid.getBoundingClientRect().top + document.documentElement.scrollTop - headerHeight - 100;
            if (!initialLoad) {
              window.scrollTo({
                  top,
                  behavior: 'smooth'
                });
              }
            }

            setTimeout(() => {
              if (typeof HulkappWishlist !== 'undefined' && HulkappWishlist) {
                HulkappWishlist._manageCollectionWL();
                
                allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
                HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
              }  
            }, 1500);
        });
      })
    }

    static renderSectionFromCache(filterDataUrl, event, instance, initialLoad) {
      const html = MainCollection2FilterForm.filterData.find(filterDataUrl).html;
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      MainCollection2FilterForm.renderFilters(parsedHTML, event);
      MainCollection2FilterForm.renderActiveFilters(parsedHTML, event);
      MainCollection2FilterForm.renderPriceRangeSlider(parsedHTML, event);
      // MainCollection2FilterForm.renderPriceRange(parsedHTML, event);
      MainCollection2FilterForm.renderSort(parsedHTML, event);
      MainCollection2FilterForm.renderAppliedFiltersCount(parsedHTML);
      MainCollection2FilterForm.renderAvailableProductsCount(parsedHTML);
      MainCollection2FilterForm.renderProductGrid(parsedHTML);
      MainCollection2FilterForm.renderInfiniteScroll(parsedHTML);

      document.documentElement.removeAttribute("main-collection-2-loading");

      requestAnimationFrame(() => {
        const productGrid = document.getElementById('product-grid');
        if (productGrid) {
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--new-header-height'), 10);
          let top = productGrid.getBoundingClientRect().top + document.documentElement.scrollTop - headerHeight - 100;
          if (!initialLoad){
            window.scrollTo({
                top,
                behavior: 'smooth'
              });
            }
          }
          setTimeout(() => {
            if (typeof HulkappWishlist !== 'undefined' && HulkappWishlist) {
            HulkappWishlist._manageCollectionWL();
            
            allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
            HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
            }  
          }, 1500);
      });

    }
    
    /*
    *  RENDER
    */

    static renderFilters(parsedHTML, event){
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#MainCollection2FilterForm .js-filter');
      const facetDetailsElementsFromDom = document.querySelectorAll('#MainCollection2FilterForm .js-filter');

      // Remove facets that are no longer returned from the server
      facetDetailsElementsFromDom.forEach(currentElement => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      })

      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };

      // const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
      const facetsToRender = Array.from(facetDetailsElementsFromFetch);
      // console.log(facetsToRender);

      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
          // Element already rendered in the DOM so just update the innerHTML
          if (!elementToRender.id.includes("filter.v.price")){
            if (currentElement) {
              document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
            } else {
              if (index > 0) {
                // Same facet type
                const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
                if (elementToRender.className === previousElementClassName) {
                  document.getElementById(previousElementId).after(elementToRender);
                  return;
                }
              }
              if (elementToRender.parentElement) {
                document.querySelector(`#${elementToRender.parentElement.id} .js-filter`)?.before(elementToRender);
              }
            }
          }
      })
      document.dispatchEvent(new CustomEvent('main-collection-2:price-range:update'));
    }

    static renderActiveFilters(parsedHTML, event){
      const activeFilterDetailsFromFetch = parsedHTML.querySelector('.main-collection-2-active-filters__wrapper'); 
      const activeFilterDetailsFromDOM = document.querySelector('.main-collection-2-active-filters__wrapper');
      const activeFilterDetailsMobileFromFetch = parsedHTML.querySelector('.main-collection-2-filter-drawer-inline-main-collection-2-active-filters__wrapper'); 
      const activeFilterDetailsMobileFromDOM = document.querySelector('.main-collection-2-filter-drawer-inline-main-collection-2-active-filters__wrapper');
      if (activeFilterDetailsFromFetch && activeFilterDetailsFromDOM){
        activeFilterDetailsFromDOM.innerHTML = activeFilterDetailsFromFetch.innerHTML;
      }
      if (activeFilterDetailsMobileFromDOM && activeFilterDetailsFromFetch){
        activeFilterDetailsMobileFromDOM.innerHTML = activeFilterDetailsMobileFromFetch.innerHTML;
      }
    }

    static renderPriceRangeSlider(parsedHTML, event){
      if (event?.type === "main-collection-2:filters:clear"){
        document.dispatchEvent(new CustomEvent("main-collection-2:price-range:clear"));
      }else{
        document.dispatchEvent(new CustomEvent("main-collection-2:price-range:update-progress"));
      }
    }

    static renderPriceRange(parsedHTML, event){
      document.querySelector("main-collection-2-price-range[checked='true'].is-loading")?.classList.remove("is-loading");
    }

    static renderSort(parsedHTML, event){
      const optionValue = event?.type === "main-collection-2:filters:clear" ? "manual" : event?.detail?.data?.option;

      if (optionValue){
        if (!optionValue) return;
        
        // CURRENT ACTIVE SORT OPTION
        document.querySelector('.js-main-collection-sort__active-option')?.classList.remove('js-main-collection-sort__active-option','!tw-text-text-neutral-100');

        // UPDATED ACTIVE SORT OPTION
        document.querySelector(`[data-sort-option][data-value="${optionValue}"]`)?.classList.add('js-main-collection-sort__active-option', '!tw-text-text-neutral-100');
        
        if (event?.type === "main-collection-2:filters:clear"){
          const label = document.querySelector("main-collection-2-sort [data-sort-label]");
          const inputEl = document.querySelector("main-collection-2-sort")?.querySelector('input');

          if (label){
            label.textContent = "Featured";
          }
          if (inputEl){
            inputEl.value = "manual";
          }
        }

        document.querySelector("main-collection-2-sort")?.classList.remove("is-loading");
        document.querySelectorAll(".main-collection-2-bottom-bar button[data-sort-trigger]").forEach(trigger => {
          // console.log(trigger);
          trigger.classList.remove("main-collection-2-sort--loading");
        });
      }
    }

    static renderAppliedFiltersCount(parsedHTML){
      const appliedFiltersCountDOM = document.getElementById('MainCollection2AppliedFiltersCount');
      const appliedFiltersCountFromFetch = parsedHTML?.querySelector("#MainCollection2AppliedFiltersCount");
      if (appliedFiltersCountFromFetch && appliedFiltersCountDOM){
        appliedFiltersCountDOM.innerHTML = appliedFiltersCountFromFetch.innerHTML;
      }
    }

    static renderAvailableProductsCount(parsedHTML){
      const availableProductsCountElFromFetch = parsedHTML?.querySelector('.js-main-collection-2-available-products-count');
      const availableProductsCountElFromDOM = document.querySelector('.js-main-collection-2-available-products-count');
      const footerAvailableProductsCountElFromFetch = parsedHTML?.querySelector('.main-collection-2-filter-drawer-sticky-bottom-bar-available-products');
      const footerAvailableProductsCountElFromDOM = document.querySelector('.main-collection-2-filter-drawer-sticky-bottom-bar-available-products');
      if (availableProductsCountElFromFetch && availableProductsCountElFromDOM){
        availableProductsCountElFromDOM.innerHTML = availableProductsCountElFromFetch.innerHTML;
      }
      if(footerAvailableProductsCountElFromDOM && footerAvailableProductsCountElFromFetch){
        footerAvailableProductsCountElFromDOM.innerHTML = footerAvailableProductsCountElFromFetch.innerHTML;
      }
    }

    static renderProductGrid(parsedHTML){
      MainCollection2FilterForm.renderInlineFilters(parsedHTML);
      document.getElementById('product-grid').innerHTML = parsedHTML.getElementById('product-grid').innerHTML;
    }

    static renderInlineFilters(parsedHTML){
      document.querySelectorAll('.product-grid-2-inline-filters__wrapper').forEach(wrapper => {
        const inlineFilterActivePanelsFromDOM = wrapper.querySelectorAll('.product-grid-2-inline-filters__panel--active');
        inlineFilterActivePanelsFromDOM.forEach(({dataset}) => {
          parsedHTML.querySelector(`[data-position="${wrapper.dataset.position}"] .product-grid-2-inline-filters__panel-trigger[data-name="${dataset.name}"]`)?.parentElement.querySelector(".product-grid-2-inline-filters__panel-trigger--active")?.classList.toggle('product-grid-2-inline-filters__panel-trigger--active');
          parsedHTML.querySelector(`[data-position="${wrapper.dataset.position}"] .product-grid-2-inline-filters__panel[data-name="${dataset.name}"]`)?.parentElement.querySelector('.product-grid-2-inline-filters__panel--active')?.classList.toggle('product-grid-2-inline-filters__panel--active');
          parsedHTML.querySelector(`[data-position="${wrapper.dataset.position}"] .product-grid-2-inline-filters__panel-trigger[data-name="${dataset.name}"]`)?.classList.add('product-grid-2-inline-filters__panel-trigger--active');
          parsedHTML.querySelector(`[data-position="${wrapper.dataset.position}"] .product-grid-2-inline-filters__panel[data-name="${dataset.name}"]`)?.classList.add('product-grid-2-inline-filters__panel--active');
        }) 
      })
    }

    static renderInfiniteScroll(parsedHTML){
      const loader = document.querySelector('main-collection-2-infinite-scroll-loader');
      if (loader) {
        loader.dataset.pages =
          parsedHTML.querySelector('main-collection-2-infinite-scroll-loader')?.dataset.pages ??
          loader.dataset.pages;
      }
      document.dispatchEvent(new CustomEvent("main-collection-2:infinite-scroll:reset"))
    }

    /*
    *  RENDER
    */

    static clearFilters(event, instance){
      event.preventDefault();
      // remove filter params
      const url = new URL(window.location);
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });
      
      url.searchParams.set('filter.v.availability', '1');

      // update URL without refresh
      window.history.pushState({}, '', url);
      MainCollection2FilterForm.renderPage( "filter.v.availability=1", event, instance)
    }

    
    static updateClearFilterButtonVisibility(searchParams){
      const params = new URLSearchParams(searchParams);
      const hasFiltersExcludingAvailability = [...params.keys()].some( key => key.startsWith("filter.") && key !== "filter.v.availability");
      const hasSort = [...params.keys()].some(key=> key.startsWith("sort_by") && key !== "manual");
      const select = document.getElementById("jsDesktopClearFilterBtn");
      select?.classList.toggle("tw-hidden", !hasFiltersExcludingAvailability);
      if (hasFiltersExcludingAvailability){
        document.documentElement.setAttribute("filter-applied", "true");
      }else{
        document.documentElement.removeAttribute("filter-applied");
      }

      if (hasSort){
        document.documentElement.setAttribute("sort-applied", "true");
      }else{
        document.documentElement.removeAttribute("sort-applied");
      }
    }

    static activeFilter(event){
      const id = event.detail.data.element.dataset.id;
      const searchParams = new URLSearchParams(window.location.search);
      const [key, value] = id.split("=");
      const newParams = new URLSearchParams();
      for (const [paramKey, paramValue] of searchParams) {
        if (paramKey !== key || paramValue !== value) {
              newParams.append(paramKey, paramValue);
          }
      }
      MainCollection2FilterForm.renderPage(
        newParams.toString(),
        null,
        false, 
        true,
        false
      );  
      
    }


    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
    

    static getSections() {
      return [
        {
          section: document.getElementById('product-grid')?.dataset?.id,
        },
      ];
    }

    static publishEvents(event){
      // BRANCH EVENTS
      // FILTER APPLIED
      if (event?.target?.name?.startsWith("filter.")){
        const filterName = event?.target?.value;
        if (filterName && event.target.checked){
          window.dispatchEvent(
            new CustomEvent("filter:applied", {
              bubbles: true,
              detail: {
                data: {filterName}
              }
            })
          );
        }
      }
      // SORT_APPLIED
      if (event?.detail?.data?.event == "sort-applied"){
        const sortValue = event?.detail?.data?.option;
        if (sortValue){
          window.dispatchEvent(
            new CustomEvent("sort:applied", {
              bubbles: true,
              detail: {
                data: {sortValue}
              }
            })
          );
        }
      }
    }
    createSearchParams(form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      // TO STRIP THE EMPTY PRICE PARAMS
      [...searchParams.entries()].forEach(([key, value]) => {
        if (
          key.startsWith('filter.v.price') &&
          value.trim() === ''
        ) {
          searchParams.delete(key);
        }
      });

      return searchParams.toString();
    }

    onSubmitForm(searchParams, event, instance) {
      MainCollection2FilterForm.renderPage(searchParams, event, instance);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const sortFilterForm = document.querySelectorAll('main-collection-2-filter-form form');
      const forms = [];
      sortFilterForm.forEach(form => {
        forms.push(this.createSearchParams(form))
      });
      this.onSubmitForm(forms.join('&'), event, this);
    }
  }

  MainCollection2FilterForm.filterData = [];
  MainCollection2FilterForm.searchParamsInitial = window.location.search.slice(1);
  MainCollection2FilterForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('main-collection-2-filter-form', MainCollection2FilterForm);
  MainCollection2FilterForm.setListeners();
}

document.addEventListener("DOMContentLoaded", () => {
  const backToTop = document.querySelector("#back-to-top");

  if (!backToTop) return;

  backToTop.classList.add("tw-hidden");

  window.addEventListener("scroll", () => {
    backToTop.classList.toggle("tw-hidden", window.scrollY < 500);
  });

  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});